import { type CrossBrandMallHomeCampaign } from '@hooks-api/types/dataModel/cross-brand-mall'
import { useEffect } from 'react'
import { useBrandNewArrivalProducts } from '../hooks/use-brand-new-arrival-products'
import { type BrandAvailability } from '../hooks/use-eligible-brand-selection'

interface BrandNewArrivalAvailabilityCheckerProps {
  campaign: CrossBrandMallHomeCampaign
  onAvailabilityChange: (campaignId: number, availability: BrandAvailability) => void
}

/**
 * 預載該品牌的 catalog API，依新品結果回報「此品牌是否有新品可顯示」。
 */
export const BrandNewArrivalAvailabilityChecker = (props: BrandNewArrivalAvailabilityCheckerProps) => {
  const { campaign, onAvailabilityChange } = props

  const { productCardEntries, isProductsLoading } = useBrandNewArrivalProducts({ campaign })

  useEffect(function reportNewArrivalAvailability() {
    onAvailabilityChange(campaign.campaign_id, {
      hasContent: productCardEntries.length > 0,
      isLoading: isProductsLoading,
    })
  }, [campaign.campaign_id, productCardEntries.length, isProductsLoading, onAvailabilityChange])

  return null
}
